import 'js-cloudimage-360-view'

import React, { FC, useEffect } from 'react'
import styled from 'styled-components'

type Props = {
  id: string
  folder: string
  filenameX: string
  filenameY?: string
  amountX: string
  amountY?: string
  speed?: string
  hide360Logo?: boolean
  fullscreen?: boolean
  ratio?: {
    x: number
    y: number
  }
  inPopup?: boolean
}
export const View360: FC<Props> = ({
  id,
  folder,
  filenameX,
  filenameY = '',
  amountX,
  amountY = '',
  hide360Logo = true,
  fullscreen = false,
  ratio = { x: 16, y: 9 },
  speed = '120',
  inPopup = false
}) => {
  useEffect(() => {
    if (!window.CI360) return
    add360View(id)
  }, [])

  return (
    <Wrapper
      id={id}
      ratio={ratio}
      className="cloudimage-360"
      data-folder={folder}
      data-filename-x={filenameX}
      data-filename-y={filenameY}
      data-amount-x={amountX}
      data-amount-y={amountY}
      data-hide-360-logo={hide360Logo}
      data-fullscreen={fullscreen}
      data-speed={speed}
      inPopup={inPopup}
    />
  )
}

function add360View(viewId: string) {
  const new360View = document.getElementById(viewId)
  if (new360View === null) return
  new360View.classList.add('cloudimage-360')
  window.CI360.add(viewId)
}

const Wrapper = styled.div<{ ratio: { x: number; y: number }; inPopup: boolean }>`
  position: relative;
  height: 0;
  padding-bottom: ${({ ratio }) => `${(ratio.y / ratio.x) * 100}%`};

  .cloudimage-360-inner-box {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .cloudimage-360-inner-box canvas {
    height: 100%;
  }

  .cloudimage-360-icons-container {
    display: none;
  }
`
